<template>
  <div >
    <vs-popup
      
      :title="$t('UnitPrices')"
      :active.sync="showModal"
      id="item-popup"
    >

    <div class="vx-card mt-5">
      <div class="vx-card__body card-body">

        <div class="vx-row mt-5">
          <div
            class="vx-col w-full mb-base"
            v-if="model.purchaseOrderItems && model.purchaseOrderItems.length > 0"
          >
            <vs-table
              :data="model.purchaseOrderItems"
              class="custom-tbl"
              id="colored-table"
            >
              <template slot="thead">
                <th style="width: 20%">{{ $t("ProductName") }}</th>
                <th style="width: 20%">{{ $t("ModelNumber") }}</th>
                <th style="width: 20%">{{ $t("UnitPrices") }}</th>

              </template>

              <template slot-scope="{ data }">
                <vs-tr v-for="(row, index) in data" :key="index">
                  <vs-td>
                    {{ row.purchaseOrderProductInfo.name }}
                  </vs-td>
                  <vs-td>
                    {{ row.purchaseOrderProductInfo.modelNumber }}
                  </vs-td>
                  <vs-td>
                    <vs-input
                      type="text"
                      :value="formatPrice(row.unitPrice)"
                      @input="(event) => updatePrice(event, row)"
                    />
                  </vs-td>
                </vs-tr>
              </template>
            </vs-table>
          </div>
          <div class="flex justify-end w-full ml-5">
            <vs-button
                type="filled"
                v-has-permission="'UpdateUnitPriceOfPurchaseOrderItem'"
                @click.prevent="saveUnit"
              >
                <span> {{ $t("SaveUnitPrice") }}</span>
              </vs-button>
          </div>

        </div>

      </div>
    </div>
    </vs-popup>
  </div>
</template>
<style lang="scss">
#item-popup .vs-popup--content {
  overflow-y: scroll !important;
}
#item-popup  .vs-popup {
  width: 900px !important;
}
</style>
<script>
import { mapActions } from "vuex";
import DataGrid from "@/components/datagrid/DataGrid";
export default {
  props: {
    show: { default: false },
    model: { default: {} }
  },
  data() {
    return {
      gridSearchData: {},

    };
  },
  computed: {
    showModal: {
      get: function() {
        return this.show;
      },
      set: function() {
        this.$emit("finish");
      }
    }
  },
  components: {
    DataGrid
  },
  methods: {
    ...mapActions({
      saveUnitFunction: "purchaseOrder/saveUnitPrice",

    }),
    formatPrice(value) {
      if (!value) return value;
      return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    updatePrice(event, row) {
      const value = event.replace(/,/g, "");
      row.unitPrice = parseFloat(value);
    },
    saveUnit() {
      const payload = {
        purchaseOrderId: this.model.id,
        purchaseOrderItems: this.model.purchaseOrderItems,
      };
      this.saveUnitFunction(payload).then((r) => {
        this.$swal({
          position: "center-center",
          type: "success",
          text: "قیمت واحد مورد نظر ویرایش شد",
          showConfirmButton: false,
          timer: 2000,
        })
          .then(() => {
            this.$emit("finish");
          })
          .catch(() => {
            this.$emit("finish");
            console.log("error");
          });
      });
    },
  }
};
</script>
